import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import Vibe from "../views/Vibe.vue";
import News from "../views/News.vue";
import About from "../views/About.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Vibe // Home
  },
  {
    path: "/news",
    name: "news",
    component: News
  },
  {
    path: "/about",
    name: "about",
    component: About
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
